// extracted by mini-css-extract-plugin
var _1 = "empty-image-small__SPOWU";
export { _1 as "emptyImageSmall" }
